module.exports = __webpack_public_path__ + "img/s6img2_low.b33aa97.8887ccf3.png";